<template>
  <ux-form
    ref="form"
    class="add-field-input x-flex-align"
    :data="formData"
    :rules="rules"
    :show-message="false"
    label-width="0px"
    :hideBtn="true"
  >
    <ux-form-item prop="name" :style="flexStyle(0)">
      <ux-input v-model="formData.name" size="small" :placeholder="$t('HT.pleaseInput')"></ux-input>
    </ux-form-item>
    <ux-form-item prop="position" :style="flexStyle(1)">
      <ux-select v-model="formData.position" size="small" :options="$opt.parameter"></ux-select>
    </ux-form-item>
    <ux-form-item prop="type" :style="flexStyle(2)">
      <ux-select v-model="formData.type" size="small" :options="$opt.dataType"></ux-select>
    </ux-form-item>
    <ux-form-item prop="required" :style="flexStyle(3)">
      <ux-checkbox style="padding-left: 10px" v-model="formData.required"></ux-checkbox>
    </ux-form-item>
    <ux-form-item prop="default_value" :style="flexStyle(4)">
      <ux-input v-model="formData.default_value" size="small" :placeholder="$t('HT.pleaseInput')"></ux-input>
    </ux-form-item>
    <ux-form-item prop="example" :style="flexStyle(5)">
      <ux-input v-model="formData.example" size="small" :placeholder="$t('HT.pleaseInput')"></ux-input>
    </ux-form-item>
    <ux-form-item prop="remark" :style="flexStyle(6)">
      <ux-input
        v-model="formData.remark"
        size="small"
        :maxlength="50"
        :placeholder="$t('HT.pleaseInput')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item class="x-flex-center" :style="flexStyle(7)">
      <span class="x-table-blue-btn" @click="del">{{ $t('HT.remove') }}</span>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    columns: {
      // 表头数据
      type: Array
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: this.data,
      rules: this.$rul.params()
    };
  },

  methods: {
    edit() {
      this.$emit('edit');
    },

    del() {
      this.$emit('del');
    },

    /**
     * 生成表单和表格对应的每个宽度布局
     * @param {Array} index 查询对象
     */
    flexStyle(index) {
      let width = this.columns[index]['width'];
      if (width === undefined) {
        // 无设置width
        return { flex: 1 };
      }
      if (typeof width === 'number') {
        return { 'flex-basis': width + 'px' };
      }
      if (width.indexOf('px')) {
        // width添加单位px
        return { 'flex-basis': width };
      } else {
        return { 'flex-basis': width + 'px' };
      }
    }
  },
  watch: {
    data: {
      handler(val) {
        this.formData = val;
        // for (const key in val) {
        //     this.$set(this.data, key, val[key]);
        // }
        this.formData.sort_num = val.index + 1;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.add-field-input {
  width: 100%;
  height: 100%;

  .ux-form-item {
    padding: 0 10px;
    margin-bottom: 0 !important ;
  }
}
</style>
